import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { NotificationService } from "src/app/notifications/notification.service";
import { UiService } from "src/app/ui/ui.service";
import { AuthService } from "../auth.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  loginForm = new FormGroup({
    email: new FormControl("", [Validators.required, Validators.email]),
    password: new FormControl("", [Validators.required]),
  });
  private onComponentDestroy = new Subject();

  constructor(
    private router: Router,
    private AuthService: AuthService,
    private NotificationService: NotificationService,
    private uiService: UiService,
  ) {}

  ngOnInit(): void {}

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  login() {
    this.uiService
      .waitForEvent(
        this.AuthService.login(
          this.loginForm.controls.email.value,
          this.loginForm.controls.password.value,
        ),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(
        () => {
          this.NotificationService.openSuccessSnackBar("Logged In");
          this.router.navigate(["dashboard"]);
        },
        (err) => {
          this.NotificationService.openErrorSnackBar(
            err?.error?.message ?? "Error attempting to login",
          );
        },
      );
  }

  forgotPassword() {
    this.router.navigate(["auth", "forgotPassword"]);
  }
}
